import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=9ff7cd6c"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ff7cd6c')) {
      api.createRecord('9ff7cd6c', component.options)
    } else {
      api.reload('9ff7cd6c', component.options)
    }
    module.hot.accept("./UserView.vue?vue&type=template&id=9ff7cd6c", function () {
      api.rerender('9ff7cd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserView.vue"
export default component.exports